module.exports = __webpack_public_path__ + "img/img82.e7a41ac6.png";